import { CreatePasswordComponent } from './app/registration/create-password/create-password.component';
import { Routes } from '@angular/router'
import { AppComponent } from './app/sainik.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { BasicRegistrationComponent } from './app/sainik-registration/basic-registration/basic-registration.component';
import { SainikRegistrationComponent } from './app/sainik-registration/sainik-registration.component';
import { Form1Component } from './app/forms/form1/form1.component';
import { FormViewComponent } from './app/forms/form-view/form-view.component';
import { GrievenceLodgingComponent } from './app/grievence-lodging/grievence-lodging/grievence-lodging.component';
//import { CorrespondenceTrackingComponent } from './app/correspondence-tracking/correspondence-tracking.component';
import { FundManagementComponent } from './app/fund-management/fund-management.component';
import { GrievenceAddressingComponent } from './app/Grievances-Addressing/grievence-addressing/grievence-addressing.component';
import { OtherModules } from './app/OtherNodules.component';
import { AwardsComponent } from './app/sainik-registration/awards/awards.component';
import { BasicRegFromViewComponent } from './app/sainik-registration/basic-reg-from-view/basic-reg-from-view.component';
import { UploadsComponent } from './app/sainik-registration/uploads/uploads.component';
import { BankinfoComponent } from './app/sainik-registration/bankinfo/bankinfo.component';
import { DependentsComponent } from './app/sainik-registration/dependents/dependents.component';
import { PensionComponent } from './app/sainik-registration/pension/pension.component';
import { BattlecasualtyComponent } from './app/sainik-registration/battlecasualty/battlecasualty.component';
import { OfficeGridComponent } from './app/ultilities/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './app/ultilities/office/office-form/office-form.component';
import { DashboardComponent } from './app/schemes/dashboard/dashboard.component';
import { SainikAccountComponent } from './app/registration/sainik-account/sainik-account.component';
import { FinanceComponent } from './app/finance/finance.component';
import {AccheadGridComponent } from './app/finance/acchead-grid/acchead-grid.component';
import {AccountHeadComponent} from './app/Finance/account-head/account-head.component';
import {SubheadGridComponent } from './app/finance/subhead-grid/subhead-grid.component';
import {SubHeadComponent} from './app/Finance/sub-head/sub-head.component';
//import { TransactionComponent } from '.app/finance/transaction/transaction.component';
import { TransactionGridComponent } from './app/finance/transaction-grid/transaction-grid.component';
import { TransactionComponent } from './app/finance/transaction/transaction.component';
import { CreatePasswordphComponent } from './app/registration/create-passwordph/create-passwordph.component';
import { SchemesComponent } from './app/schemes/schemes.component';
import { ApplicationsGridComponent } from './app/schemes/applications-grid/applications-grid.component';
import { ApplicationHistoryComponent } from './app/schemes/application-history/application-history.component';
import { ApprovalsGridComponent } from './app/schemes/approvals-grid/approvals-grid.component';
import { CtGridComponent } from './app/correspondence-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './app/correspondence-tracking/ct-form/ct-form.component';
import { CorrespondanceTrackingComponent } from './app/correspondence-tracking/correspondance-tracking.component';
import { GrievenceGridComponent } from './app/grievence-lodging/grievence-grid/grievence-grid.component';
import { GrievacesAddressingGridComponent } from './app/Grievances-Addressing/grievaces-addressing-grid/grievaces-addressing-grid.component';
//import { TransactionComponent } from '.app/finance/transaction/transaction.component';
//import {CreatePasswordComponent} from './app/registration/create-password/create-password.component';

export const appRoutes: Routes = [
    {
    path: 'home',component: HomepageComponent, canActivate : [AuthGuard],
    children: [
        {
            path: 'password',component: UltilitiesComponent,
            children: [{path: '', component: ChangePasswordComponent}]
        },  

        {
            path: 'password/:userId',component: UltilitiesComponent,
            children: [{path: '', component: ChangePasswordComponent}]
        },  


        {
            path: 'office', component: UltilitiesComponent,
            children: [{ path: '', component: OfficeGridComponent },
            { path: 'officeform', component: OfficeFormComponent },
            { path: 'officeform/:OfficeId/:mode', component: OfficeFormComponent }
            ]
        },
        
        {
            path: 'rolesgrid', component: UltilitiesComponent,
            children: [{ path: '', component: RolesGridComponent },
            { path: 'rolesform', component: RolesFormComponent },
            { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
            ]
        },
                                      
        

        {
            path: 'user', component: UltilitiesComponent,
            children: [{ path: '', component: UserGridComponent },
            { path: 'userform', component: UserFormComponent },
            { path: 'userform/:Id/:mode', component: UserFormComponent }
            ]
        },

        
        {
            path: 'claims', component: UltilitiesComponent,
            children: [{ path: '', component: ClaimGridComponent },
            { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
            ]
        },
        
        {
            path: 'basic-de',component: SainikRegistrationComponent,
            children: [{path: '', component: Form1Component},{path: 'de-view', component: FormViewComponent}]
        },
        // {
        //     path: 'de-view',component: SainikRegistrationComponent,
        //     children: [{path: '', component: FormViewComponent}]
        // },
        
        {
            path: 'br',component: SainikRegistrationComponent,
            children: [{path: '', component: BasicRegistrationComponent}]
        },
        {
            path: 'awards',component: SainikRegistrationComponent,
            children: [{path: '', component: AwardsComponent}]
        },
        {
            path: 'battle',component: SainikRegistrationComponent,
            children: [{path: '', component: BattlecasualtyComponent}]
        },
        {
            path: 'finance',component: OtherModules,
            children: [{path: '', component: FinanceComponent}]
        },
        {
            path: 'accounthead',component: FinanceComponent,
            children: [{path: '', component: AccheadGridComponent}]
        },
        
        {
            path: 'acchead-form',component: FinanceComponent,
            children: [{path: '', component: AccountHeadComponent}]
        },
        {
            path: 'acchead-form/:accountHead/:mode',component: FinanceComponent,
            children: [{path: '', component: AccountHeadComponent}]
        },
        {
            path: 'subhead',component: FinanceComponent,
            children: [{path: '', component: SubheadGridComponent}]
        },        
        {
            path: 'subhead-form',component: FinanceComponent,
            children: [{path: '', component: SubHeadComponent}]
        },
        {
            path: 'subhead-form/:accountHead/:accountSubHead/:mode',component: FinanceComponent,
            children: [{path: '', component: SubHeadComponent}]
        },        
        {
            path: 'FundManagement',component: FinanceComponent,
            children: [{path: '', component: TransactionGridComponent}]
        },        
        {
            path: 'fundManagement-form',component: FinanceComponent,
            children: [{path: '', component: TransactionComponent}]
        },
        {
            path: 'fundManagement-form/:expenditureId/:accountHead/:mode',component: FinanceComponent,
            children: [{path: '', component: TransactionComponent}]
        },
        {
            path: 'pension',component: SainikRegistrationComponent,
            children: [{path: '', component: PensionComponent}]
        },
        {
            path: 'dependents',component: SainikRegistrationComponent,
            children: [{path: '', component: DependentsComponent}]
        },
        {
            path: 'bank',component: SainikRegistrationComponent,
            children: [{path: '', component: BankinfoComponent}]
        },
        {
            path: 'uploads',component: SainikRegistrationComponent,
            children: [{path: '', component: UploadsComponent}]
        },
        {
            path: 'viewform',component: SainikRegistrationComponent,
            children: [{path: '', component: BasicRegFromViewComponent}]
        },
        {
            path: 'gl',component: OtherModules,
            children: [{path: '', component: GrievenceGridComponent}]
        },
        
        {
            path: 'grievance-form',component: OtherModules,
            children: [{path: '', component: GrievenceLodgingComponent}]
        },
        {
            path: 'grievance-form/:Id/:mode',component: OtherModules,
            children: [{path: '', component: GrievenceLodgingComponent}]
        },
        {
            path: 'ga',component: OtherModules,
            children: [{path: '', component: GrievacesAddressingGridComponent}]
        },
        {
            path: 'grievance-address-form/:Id/:mode',component: OtherModules,
            children: [{path: '', component: GrievenceAddressingComponent}]
        },
        
        {
            path: 'fm',component: OtherModules,
            children: [{path: '', component: FundManagementComponent}]
        },
        {
            path: 'ct',component: CorrespondanceTrackingComponent,
            children: [{path: '', component: CtGridComponent}]
        },
        {
            path: 'correspondancetracking-form',component: CorrespondanceTrackingComponent,
            children: [{path: '', component: CtFormComponent}]
        },
        {
            path: 'correspondancetracking-form/:Id/:mode',component: CorrespondanceTrackingComponent,
            children: [{path: '', component: CtFormComponent}]
        },
        
            
        {
            path: 'schemes', component: OtherModules,
            children: [{path: '', component: SchemesComponent}]  
        },

        {
            path: 'dashboardschemes',component: SchemesComponent,
            children: [{path: '', component: DashboardComponent}]
        },
        {
            path: 'SchemesApplications',component: SchemesComponent,
            children: [{path: '', component: ApplicationsGridComponent}]
        },        
        {
            path: 'Applicationstatus-history/:applicationId/:mode',component: SchemesComponent,
            children: [{path: '', component: ApplicationHistoryComponent}]
        },
        {
            path: 'SchemesApprovals',component: SchemesComponent,
            children: [{path: '', component: ApprovalsGridComponent}]
        },        
        



        
        //Sainik App Routes
    ]
    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{path: '', component: LoginComponent}]
    },
            
    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{path: '', component: ForgotPasswordComponent}]  
    },
    {
        path: 'SainikAccount/:userId/:code', component: RegistrationComponent,
        children: [{path: '', component: SainikAccountComponent}]
    },
    {
        path: 'CreatePassword/:UserId', component: RegistrationComponent,
        children: [{path: '', component: CreatePasswordComponent}]
    },        
    {
        path: 'CreatePasswordph/:UserId/:IsServiceHavingPhone', component: RegistrationComponent,
        children: [{path: '', component: CreatePasswordphComponent}]
    },    

 {
        path: 'signup', component: RegistrationComponent,
        children: [{path: '', component: SignupComponent}]  
    },

    
    
    { path : '', redirectTo:'/login', pathMatch : 'full'}

];


// WEBPACK FOOTER //
// ./src/routes.ts